module.exports = __webpack_public_path__ + "static/media/logo_white.d6265838.png";